module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-rqf-page"
  }, [(_vm.$root.fleet) ? _c('div', {
    staticClass: "partner-logo"
  }) : (_vm.$root.partnerId) ? _c('div', {
    staticClass: "partner-logo"
  }, [_c('img', {
    attrs: {
      "src": "/wp-content/plugins/autotaksering/requests/assets/img/codan_orig.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contactinfo",
    attrs: {
      "id": "contactinfo"
    }
  }, [_c('h3', [_vm._v("Ønsker du rutekontroll?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }), _vm._v(" "), _c('div', {
    staticClass: "mps-actions"
  }, [_c('button', {
    staticClass: "button primary",
    attrs: {
      "id": "gtm-inquiry-submit",
      "disabled": _vm.$root.ui.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.submitAdditionals.apply(null, arguments)
      }
    }
  }, [_vm._v("Nei, det har jeg ikke")]), _vm._v(" "), _c('button', {
    staticClass: "button secondary",
    attrs: {
      "id": "gtm-inquiry-submit",
      "disabled": _vm.$root.ui.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.submitAdditionalsGlass.apply(null, arguments)
      }
    }
  }, [_vm._v("Ja, jeg har en ruteskade")])]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Ved å si ja samtykker du til at dine kontaktdetaljer blir delt med Riis Bilglass, som vil ta kontakt med deg for å planlegge rutekontroll.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "additionals_banner"
  }, [_c('img', {
    attrs: {
      "src": "/wp-content/plugins/autotaksering/requests/assets/img/riis_frontrute.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Fiks ruten mens bilen er på verksted. Jobben utføres av vår samarbeidspartner "), _c('a', {
    attrs: {
      "href": "https://www.bilglass.no/",
      "target": "_blank"
    }
  }, [_vm._v("Riis Bilglass")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5eb64a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/Additionals.vue
// module id = 123
// module chunks = 0